import React from 'react';
import CommonUtil from '../../../../../../utils/commonUtil';

export const questionIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="14"
    height="14"
    viewBox="0 0 10 10"
    fill="none"
  >
    <path
      d="M4.5 8H5.5V7H4.5V8ZM5 0C2.24 0 0 2.24 0 5C0 7.76 2.24 10 5 10C7.76 10 10 7.76 10 5C10
      2.24 7.76 0 5 0ZM5 9C2.795 9 1 7.205 1 5C1 2.795 2.795 1 5 1C7.205 1 9 2.795 9 5C9 7.205
      7.205 9 5 9ZM5 2C3.895 2 3 2.895 3 4H4C4 3.45 4.45 3 5 3C5.55 3 6 3.45 6 4C6 5 4.5 4.875
      4.5 6.5H5.5C5.5 5.375 7 5.25 7 4C7 2.895 6.105 2 5 2Z"
      fill="#A1A1A1"
    />
  </svg>
);

export const closeIcon = (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M14 1.41L12.59 0L7 5.59L1.41 0L0 1.41L5.59 7L0 12.59L1.41 14L7 8.41L12.59 14L14 12.59L8.41 7L14 1.41Z"
      fill="#000"
    />
  </svg>
);

export const downloadContractIcon = (` 
   <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
     <path d="M18 15V18H6V15H4V18C4 19.1 4.9 20 6 20H18C19.1 20 20 19.1 20 18V15H18ZM17 11L15.59 9.59L13 12.17V4H11V12.17L8.41 9.59L7 11L12 16L17 11Z" fill="currentColor"/>
   </svg>`)

export const calendarSvgIcon = (`<svg width="20" height="20" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M19 4.5H18V2.5H16V4.5H8V2.5H6V4.5H5C3.89 4.5 3.01 5.4 3.01 6.5L3 20.5C3 21.6 3.89 22.5 5 22.5H19C20.1 22.5 21 21.6 21 20.5V6.5C21 5.4 20.1 4.5 19 4.5ZM19 20.5H5V10.5H19V20.5ZM19 8.5H5V6.5H19V8.5ZM12 13.5H17V18.5H12V13.5Z" fill="currentColor"/>
                               </svg>`)

export const calendarEventSvgIcon =(<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
  <path d="M17 13H12V18H17V13ZM16 2V4H8V2H6V4H5C3.89 4 3.01 4.9 3.01 6L3 20C3 21.1 3.89 22 5 22H19C20.1 22 21 21.1 21 20V6C21 4.9 20.1 4 19 4H18V2H16ZM19 20H5V9H19V20Z" fill="#333333"/>
</svg>)



export const eventSvgIcon = ( color = "#E10098") => {

  if(CommonUtil.getChannel()=== 'wap'){

    return `<svg xmlns="http://www.w3.org/2000/svg" width="14" height="11" viewBox="0 0 14 11" fill="${color}">
            <path d="M5 10.42L0 5.42L1.41 4.01L5 7.59L12.59 0L14 1.42L5 10.42Z" fill="white"/>
          </svg>`
  }
  
  return `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
               <rect x="3" y="3" width="18" height="18" rx="2" fill="${color}"/>
                <path d="M10 17.42L5 12.42L6.41 11.01L10 14.59L17.59 7L19 8.42L10 17.42Z" fill="white"/>
          </svg>`
}

export function getIconDataUri(svg) {
    return `data:image/svg+xml,${encodeURIComponent(svg)}`;
}

export function applyCheckboxIcon(selector, color, cssProperty = '--check-icon') {
  const svg = eventSvgIcon(color);
  const iconDataUri = getIconDataUri(svg);
  const elements = document.querySelectorAll(selector);
  
  elements.forEach(element => {
    element.style.setProperty(cssProperty, `url("${iconDataUri}")`);
  });
  
  return elements.length;
}

export function getBrandColor(varName = '--main-color-brand') {
  return getComputedStyle(document.documentElement)
    .getPropertyValue(varName).trim() || '#E10098';
}


export const downLoadGiftListIcon = (
  `<svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none">
  <path fill-rule="evenodd" clip-rule="evenodd" d="M16 9V16H2V9H0V16C0 17.1 0.9 18 2 18H16C17.1 18 18 17.1 18 16V9H16ZM10 9.67L12.59 7.09L14 8.5L9 13.5L4 8.5L5.41 7.09L8 9.67V0H10V9.67Z" fill="#333333"/>
</svg>`
)

export const shareWebIcon = (
  `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
  <g clip-path="url(#clip0_18988_13634)">
    <path d="M16 5L14.58 6.42L12.99 4.83V16H11.01V4.83L9.42 6.42L8 5L12 1L16 5ZM20 10V21C20 22.1 19.1 23 18 23H6C4.89 23 4 22.1 4 21V10C4 8.89 4.89 8 6 8H9V10H6V21H18V10H15V8H18C19.1 8 20 8.89 20 10Z" fill="black"/>
  </g>
  <defs>
    <clipPath id="clip0_18988_13634">
      <rect width="24" height="24" fill="white"/>
    </clipPath>
  </defs>
</svg>`
)